<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M2.5 10C2.5 13.728 5.52208 16.75 9.25 16.75C12.978 16.75 16 13.728 16 10C16 6.27208 12.978 3.25 9.25 3.25C5.52208 3.25 2.5 6.27208 2.5 10Z" 
    stroke="currentColor" stroke-width="1.5"/>
    <path d="M9 7V10L11 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'OpIsWithinLast',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>